export enum WorkOrderMissionType {
    Supply = 1,
    Return = 2,
}
